export default "__VITE_ASSET__VL5syPeP__"